import { Link } from "react-router-dom";
import { useAuth } from "./context/authContext";
import { useSidebar } from "./context/sidebarContext";

export default function NavbarMobile() {
  const { subscription } = useAuth();
  const { toggleSidebar, setIsOpenUpgradeDialog } = useSidebar();

  // Logic adapted from Sidebar to determine if the Upgrade button should show
  const showUpgradeButton = () => {
    // 1. No subscription at all → Show Upgrade
    if (!subscription) return true;

    // 2. If user is on free plan (status "trialing") → Show Upgrade
    if (subscription.status === "trialing") return true;

    // 3. If user has trial dates AND still inside trial → Show Upgrade
    if (subscription.trial_end && subscription.trial_end * 1000 > Date.now()) {
      return true;
    }

    // 4. User already has a paid plan → Hide Upgrade
    return false;
  };

  return (
    <div className="flex xl:hidden px-6 py-4 bg-[#F0F0FF] border-b items-center border border-[#DDE1E6]">
      <img
        src="/images/icons/icon_nav_mobile_drawer.svg"
        alt="drawer"
        className="cursor-pointer"
        onClick={toggleSidebar}
      />
      <div className="w-[1px] h-9 bg-[#D1D1D6] mx-2"></div>
      <Link to="/dashboard">
        <img
          src="/images/icons/icon_xenorize.svg"
          alt="xeno"
          className="cursor-pointer max-w-[125px]"
        />
      </Link>
 
      {/* Conditionally render based on the logic above */}
      {showUpgradeButton() && (
        <div
          className="ml-auto text-red-500 bg-white rounded-lg py-1 pl-4 pr-3 flex gap-1 text-sm items-center cursor-pointer shadow-sm border border-gray-100"
          onClick={() => setIsOpenUpgradeDialog(true)}
        >
          Upgrade
          <img src="/images/icons/icon_wallet_upgrade.svg" alt="upgrade" />
        </div>
      )}
    </div>
  );
}
